<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-desired-stock-sidebar ref="desiredStockSidebar" />

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        @selected="onClicked(selected)"
        pagination
        search
        :max-items="100"
        :data="filteredVenueStock"
      >
        <template slot="thead">
          <vs-th sort-key="number">Number</vs-th>
          <vs-th sort-key="displayName">Name</vs-th>
          <vs-th>Min/Desired</vs-th>
          <vs-th>Locations (desired)</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <p class="ml-4">{{ tr.stockProductId.id }}</p>
                </div>
              </vs-td>

              <vs-td>
                <div>
                  {{ tr.displayName }}
                </div>
              </vs-td>
              <vs-td>
                <vs-row>
                  <vs-chip color="danger" class="mr-2">{{
                    tr.venue.minimumAmount
                  }}</vs-chip>
                  /
                  <vs-chip class="ml-2" color="warning">{{
                    tr.venue.desiredAmount
                  }}</vs-chip>
                </vs-row>
              </vs-td>
              <vs-td>
                <vs-chip>
                  <div class="flex">
                    <div class="mr-2">
                      {{ getStockLocationStatusString(tr.stocks) }}
                    </div>

                    <vx-tooltip
                      :text="getStockProductExplanationString(tr.stocks)"
                      position="bottom"
                    >
                      <feather-icon
                        icon="InfoIcon"
                        svg-classes="h-4 w-4"
                        class="ml-1"
                      />
                    </vx-tooltip>
                  </div>
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleDesiredStockSidebar from "./HandleDesiredStockSidebar";

export default {
  components: {
    HandleDesiredStockSidebar,
  },
  data() {
    return {
      selected: [],
      filterByLocationId: "",
      isLoading: true,
      ProductIcon,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    onClicked(desiredStock) {
      console.log("Clicked", desiredStock);
      this.$refs.desiredStockSidebar.show(desiredStock);
    },
    /* async onClickCreateNew() {
      this.$refs.productRequestSidebar.showEmptyProduct();
    }, */

    getStockLocationStatusString(stocks) {
      return stocks
        .map((e) => {
          // const location = this.pimStockLocations.locations.find(l => l.id === e.stockId.id);
          return `${e.desiredAmount}`;
        })
        .join(" ");
    },

    getStockProductExplanationString(stocks) {
      return stocks
        .map((e) => {
          const location = this.pimStockLocations.locations.find(
            (l) => l.id === e.stockId.id
          );
          if (!location) return "";
          return `${location.name}: ${e.desiredAmount}`;
        })
        .join(" | ");
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      stockProducts: "stockProducts/stockProducts",
      totalProductsCount: "stockProducts/totalProductsCount",
      pimStockLocations: "venues/pimStockLocations",
      activeVenueId: "venues/activeVenueId",
      venueDesiredStock: "pimVenues/venueDesiredStock",
    }),
    filteredVenueStock() {
      return this.venueDesiredStock;
    },
  },

  async created() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch(
        "pimVenues/getVenueDesiredStock",
        this.activeVenueId
      ),
      this.$store.dispatch("venues/getPimStockLocations", this.activeVenueId),
    ]);
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
